export default __webpack_public_path__ + "static/media/krispyKreme.229eaa69.jpg";